var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframeRef",staticStyle:{"height":"100%","width":"100%"},attrs:{"allow":"payment;camera","title":"withdraw","frameBorder":"0","src":_vm.url,"scrolling":_vm.args.handleHeightChange ? 'no' : 'yes'}})}
var staticRenderFns = []

export { render, staticRenderFns }